import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  return auth.initialize().pipe(
    map((authenticated) => {
      if (authenticated) return true;
      auth.login(state.url || '/');
      return false;
    })
  );
};
